import styled from 'styled-components';
import ButtonRow from './ButtonRow';

export interface PageHeaderProps {
  readonly title: string;
  readonly subtitle?: string | null;
  readonly className?: string;
  readonly children?: React.ReactNode;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  margin-bottom: 1.5rem;
`;

const TitleAndActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default function PageHeader({
  title,
  subtitle,
  className,
  children,
}: PageHeaderProps) {
  return (
    <Wrapper className={className}>
      <TitleAndActions>
        <h2 className="my-0">{title}</h2>

        {children && <ButtonRow className="ps-5">{children}</ButtonRow>}
      </TitleAndActions>

      {subtitle && <h4 className="fw-normal">{subtitle}</h4>}
    </Wrapper>
  );
}
